import { makeObservable, observable, runInAction } from 'mobx';

import { injectable } from '@servicetitan/react-ioc';
import { QueryApiOptions, QueryApiStore } from '@servicetitan/tanstack-query-mobx';

import { EstimateApiModel } from '../../api/job-details.api';
import { MainStore } from '../../stores/main.store';
import { EstimateViewModel } from '../models/estimate-view.model';

@injectable()
export class EstimateSelectStore extends QueryApiStore {
    @observable estimates: EstimateViewModel[] = [];

    constructor(private readonly mainStore: MainStore) {
        super();
        makeObservable(this);
    }

    get queryOptions(): QueryApiOptions<EstimateApiModel[]> {
        return {
            queryKey: ['get-estimate-list'],
            enabled: true,
            queryFn: () => {
                return this.mainStore.jobDetails?.estimates ?? [];
            },
            onSuccess: data => {
                runInAction(() => {
                    this.estimates = data.map(x => {
                        return {
                            id: x.id,
                            label: x.name,
                        };
                    });
                });
            },
        };
    }
}
